import "./HeaderTitle.css"



function HeaderTitle(props) {
    return (<div className="banner_background">{props.title}</div>)
  }

export default HeaderTitle